import { render } from "./CreatePetition.vue?vue&type=template&id=2d31080e"
import script from "./CreatePetition.vue?vue&type=script&lang=js"
export * from "./CreatePetition.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "E:\\wamp64\\www\\law-firm-system-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__